import { noop } from 'lodash';

export const hideKeyboard = noop;
